export const IMAGE_BASE = 'https://www.wir-gastfreunde.de/fileadmin/user_upload/Wir-Gastfreunde-Relaunch/12_Bilder_Boerse/'

export const MAIN_ADDRESS_TYPE_ID = 1 // "Hauptadresse"
